// ** Router imports
import { lazy } from "react";
import Cookies from "js-cookie";

// ** Router imports
import { useRoutes, Navigate } from "react-router-dom";

// ** Layouts
import BlankLayout from "@layouts/BlankLayout";

// ** Utils
import { getUserData, getHomeRouteForLoggedInUser } from "../../utility/Utils";

// ** Components
const Error = lazy(() => import("../../views/pages/misc/Error"));
const Login = lazy(() => import("../../Entry/EntryComponents/Login"));

const ResetPassword = lazy(() =>
  import("../../Entry/EntryComponents/ResetPassword")
);
const Register = lazy(() => import("../../Entry/EntryComponents/Register"));

const ConfirmEmail = lazy(() =>
  import("../../Entry/EntryComponents/confirm_email")
);

const Router = ({ allRoutes }) => {
  const getHomeRoute = () => {
    const user = getUserData();
    if (user) {
      return getHomeRouteForLoggedInUser("admin");
    } else {
      return "/login";
    }
  };

  const routes = useRoutes([
    {
      path: "/",
      index: true,
      element: <Navigate replace to={getHomeRoute()} />,
    },
    {
      path: "/login",
      element: <BlankLayout />,
      children: [{ path: "/login", element: <Login /> }],
    },
    {
      path: "/register",
      element: <BlankLayout />,
      children: [{ path: "/register", element: <Register /> }],
    },
    {
      path: "/resetPassword",
      element: <BlankLayout />,
      children: [{ path: "/resetPassword", element: <ResetPassword /> }],
    },
    {
      path: "/recovery-password/:resetPasswordToken",
      element: <BlankLayout />,
      children: [
        {
          path: "/recovery-password/:resetPasswordToken",
          element: <ResetPassword />,
        },
      ],
    },
    {
      path: "/register/confirm",
      element: <BlankLayout />,
      children: [
        {
          path: "/register/confirm",
          element: <ConfirmEmail />,
        },
      ],
    },
    {
      path: "/register",
      element: <BlankLayout />,
      children: [
        {
          path: "/register/confirm=/:confirmationToken",
          element: <ConfirmEmail />,
        },
      ],
    },
    {
      path: "*",
      element: <BlankLayout />,
      children: [{ path: "*", element: <Error /> }],
    },
    ...allRoutes,
  ]);

  return routes;
};

export default Router;
